import styled from 'styled-components'
import { DEVICE } from '../../../util/constants'
import { RegionContainer } from '../../styles/Utility.styles'
import { DateBox, MultiDateBox } from './CalendarOfEventsBlock.styles'

const DESKTOP_DATE_COLUMN_WIDTH = 93
const DESKTOP_DATE_COLUMN_MARGIN_LEFT = 29
const MOBILE_DATE_ROW_HEIGHT = 75

export const EventListingBlock = styled(RegionContainer)`
  margin-top: 0;
`

export const EventListingFlexContainer = styled.div`
  grid-column: 2 / 3;
  grid-row: auto;
  display: flex;
  flex-direction: column;

  @media ${DEVICE.tabletL} {
    flex-direction: row;
  }

  [data-layout='two-column'] & {
    @media ${DEVICE.laptopG} {
      grid-column: span 3;
    }
  }
`

export const EventDateFlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0 0 22px;

  @media ${DEVICE.tabletL} {
    flex-direction: column;
    flex: 0 0 93px;
    margin-right: ${DESKTOP_DATE_COLUMN_MARGIN_LEFT}px;
  }

  img {
    border-radius: 0;
    height: ${MOBILE_DATE_ROW_HEIGHT}px;

    @media ${DEVICE.tabletL} {
      flex-direction: column;
      flex: 0 0 93px;
      width: ${DESKTOP_DATE_COLUMN_WIDTH}px;
      height: 83px;
    }
  }
`

export const EventListingDateBox = styled(DateBox)`
  width: 85px;
  height: ${MOBILE_DATE_ROW_HEIGHT}px;
  margin-bottom: 0;

  @media ${DEVICE.tabletL} {
    width: ${DESKTOP_DATE_COLUMN_WIDTH}px;
    height: 83px;
  }
`

export const EventListingMultiDateBox = styled(MultiDateBox)`
  width: 85px;
  height: ${MOBILE_DATE_ROW_HEIGHT}px;
  margin-bottom: 0;

  @media ${DEVICE.tabletL} {
    width: ${DESKTOP_DATE_COLUMN_WIDTH}px;
    height: 83px;
  }
`

export const EventTextRegion = styled.div`
  color: var(--content-background-dark-blue);

  @media ${DEVICE.tabletL} {
    flex-basis: auto;
    padding-right: 30px;
  }

  h2 {
    font-size: 2.8rem;
    padding-bottom: 14px;
    line-height: 1.35;

    @media ${DEVICE.tabletL} {
      font-size: 2.4rem;
      padding-bottom: 14px;
    }
  }

  p {
    font-size: 1.4rem;
    line-height: 2.4rem;

    @media ${DEVICE.tabletL} {
      font-size: 1.6rem;
    }
  }
`
export const EventDetailsFlexContainer = styled.aside`
  @media ${DEVICE.tabletL} {
    flex: 0 0 215px;
    flex-grow: 0;
    display: flex;
    flex-direction: column;
  }

  h3 {
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 1.71;
    letter-spacing: 0.02em;
    color: var(--highlight-blue);
    padding: 16px 0 0;

    @media ${DEVICE.tabletL} {
      padding: 0 0 6px;
    }
  }

  p {
    font-size: 1.4rem;
    line-height: 1.5;
    color: var(--content-background-dark-blue);

    @media ${DEVICE.tabletL} {
      font-size: 1.6rem;

      :first-of-type {
        line-height: 2;
        margin-bottom: 11px;
      }
    }
  }
`

export const DividerRow = styled.hr`
  /* margin-left: ; */
  grid-column: 2 / 3;
  border-top: 2px solid var(--graphic-accent-blue-2);
  margin-bottom: 27px;

  @media ${DEVICE.tabletL} {
    grid-column: 2 / 3;
    grid-row: auto;
    margin: 26px 0 34px
      ${DESKTOP_DATE_COLUMN_WIDTH + DESKTOP_DATE_COLUMN_MARGIN_LEFT}px;
  }

  [data-layout='two-column'] & {
    @media ${DEVICE.laptopG} {
      grid-column: span 3;
    }
  }
`

export const additionalCtaStyles = `
  grid-column: 2 / 12;
  padding: 17px 0 27px 0;

  @media ${DEVICE.tabletL} {
    padding-bottom: 36px;
    margin-left: ${
      DESKTOP_DATE_COLUMN_WIDTH + DESKTOP_DATE_COLUMN_MARGIN_LEFT
    }px;
  }
  [data-layout="two-column"] & {
    @media ${DEVICE.laptopG} {
      grid-column: span 12;
    }
  }
`
